import { Duration } from 'src/resources/durations'

export const schedule = (delay: Duration) => {
  return new Promise((resolve) => {
    window.setTimeout(resolve, parseFloat(delay) * 1000)
  })
}
